import { render, staticRenderFns } from "./TerminalScreenshotView.vue?vue&type=template&id=5921933e&"
import script from "./TerminalScreenshotView.vue?vue&type=script&lang=js&"
export * from "./TerminalScreenshotView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports